import { UIHeading2 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './OfferHeader.css';
import { EIcons, IOptions } from '../../types/metaIcon';

interface IOfferHeaderProps {
  price: string;
  discount?: React.ReactNode;
  icons: EIcons[];
  iconOptions: IOptions;
  isHighlighted: boolean;
}

export function OfferHeader({ price, discount, isHighlighted }: IOfferHeaderProps) {
  return (
    <div className={classNames(styles['offer-header'], { [styles['with-discount']]: Boolean(discount) })}>
      <div className={classNames(styles['price'], isHighlighted && styles['highlighted'])}>
        <UIHeading2 data-testid="Price">{price}</UIHeading2>
      </div>
      <div className={styles['additional-price-info']}>{discount}</div>
    </div>
  );
}
